var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"value":_vm.value,"items":_vm.items,"autocomplete":"on"},on:{"input":_vm.selectChange}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }